import React, { Component } from 'react';
import EventTimer from './eventTimer'

let data = {
  "wm": "u",
  "i": 2028764,
  "s": {
    "i": 52,
    "n": "Tennis",
    "nch": "网球"
  },
  "r": {
    "i": 169,
    "n": "Singapore",
    "nch": "新加坡"
  },
  "l": {
    "i": 25004,
    "n": "ATP. Singapore",
    "nch": "ATP. 新加坡站"
  },
  "c1": {
    "i": null,
    "n": "Alexei Popyrin",
    "nch": "阿列克谢·波佩林",
    "k": {
      "si": "",
      "so": ""
    }
  },
  "c2": {
    "i": null,
    "n": "Matthew Ebden",
    "nch": "马修·伊布登",
    "k": {
      "si": "",
      "so": ""
    }
  },
  "et": "2021-02-26T05:45:00",
  "b": false,
  "vi": null,
  "lve": true,
  "xy": "",
  "ls": {
    "c": "11113",
    "n": "Singles serve",
    "d": "15:0^"
  },
  "p": {
    "c": 2,
    "n": "2. Set"
  },
  "dr": {
    "s": null,
    "c": "",
    "r": false,
    "inj": 0,
    "ext": {}
  },
  "ps": {
    "TN": {
      "sets": {
        "h": 1,
        "a": 0
      },
      "status": 1,
      "games": {
        "h": 6,
        "a": 4
      }
    },
    "S1": {
      "games": {
        "h": 6,
        "a": 4
      },
      "status": 255
    },
    "S2": {
      "games": {
        "h": 0,
        "a": 0
      },
      "status": 1
    }
  },
  "ms": {},
  "el": {},
  "m": [
    {
      "c": "HA",
      "a": null,
      "b": false,
      "o": [
        {
          "c": "1",
          "v": 1.49,
          "b": false
        },
        {
          "c": "2",
          "v": 2.71,
          "b": false
        }
      ]
    },
    {
      "c": "OU",
      "a": "22.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 1.6,
          "b": false
        },
        {
          "c": "Under",
          "v": 2.27,
          "b": false
        }
      ]
    },
    {
      "c": "AH",
      "a": "-2.5",
      "b": false,
      "o": [
        {
          "c": "1",
          "v": 1.87,
          "b": false
        },
        {
          "c": "2",
          "v": 1.98,
          "b": false
        }
      ]
    },
    {
      "c": "IOU_T1_G",
      "a": "12.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 1.4,
          "b": false
        },
        {
          "c": "Under",
          "v": 2.88,
          "b": false
        }
      ]
    },
    {
      "c": "IOU_T2_G",
      "a": "11.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 1.62,
          "b": false
        },
        {
          "c": "Under",
          "v": 2.24,
          "b": false
        }
      ]
    },
    {
      "c": "CS",
      "a": null,
      "b": false,
      "o": [
        {
          "c": "2:0",
          "v": 2.25,
          "b": false
        },
        {
          "c": "2:1",
          "v": 3.6,
          "b": false
        },
        {
          "c": "0:2",
          "v": 5,
          "b": false
        },
        {
          "c": "1:2",
          "v": 5,
          "b": false
        }
      ]
    },
    {
      "c": "ETS",
      "a": null,
      "b": false,
      "o": [
        {
          "c": "2",
          "v": 1.616,
          "b": false
        },
        {
          "c": "3",
          "v": 2.2,
          "b": false
        }
      ]
    },
    {
      "c": "T1_WIN_1SET",
      "a": "1",
      "b": false,
      "o": [
        {
          "c": "Yes",
          "v": 1.168,
          "b": false
        },
        {
          "c": "No",
          "v": 5,
          "b": false
        }
      ]
    },
    {
      "c": "T2_WIN_1SET",
      "a": "1",
      "b": false,
      "o": [
        {
          "c": "Yes",
          "v": 1.57,
          "b": false
        },
        {
          "c": "No",
          "v": 2.25,
          "b": false
        }
      ]
    },
    {
      "c": "HA_S1",
      "a": null,
      "b": false,
      "o": [
        {
          "c": "1",
          "v": 1.54,
          "b": false
        },
        {
          "c": "2",
          "v": 2.56,
          "b": false
        }
      ]
    },
    {
      "c": "OU_S1",
      "a": "10.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 1.6,
          "b": false
        },
        {
          "c": "Under",
          "v": 2.3,
          "b": false
        }
      ]
    },
    {
      "c": "OU_S1",
      "a": "12.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 2.17,
          "b": false
        },
        {
          "c": "Under",
          "v": 1.72,
          "b": false
        }
      ]
    },
    {
      "c": "CS_S1",
      "a": null,
      "b": false,
      "o": [
        {
          "c": "6:3",
          "v": 5.05,
          "b": false
        },
        {
          "c": "6:4",
          "v": 5.5,
          "b": false
        },
        {
          "c": "7:5",
          "v": 7.3,
          "b": false
        },
        {
          "c": "7:6",
          "v": 3.34,
          "b": false
        },
        {
          "c": "3:6",
          "v": 1.001,
          "b": true
        },
        {
          "c": "4:6",
          "v": 8.2,
          "b": false
        },
        {
          "c": "5:7",
          "v": 10,
          "b": false
        },
        {
          "c": "6:7",
          "v": 4,
          "b": false
        }
      ]
    },
    {
      "c": "AH_S2",
      "a": "-1.5",
      "b": false,
      "o": [
        {
          "c": "1",
          "v": 2.07,
          "b": false
        },
        {
          "c": "2",
          "v": 1.79,
          "b": false
        }
      ]
    },
    {
      "c": "OU_S1",
      "a": "9.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 1.14,
          "b": false
        },
        {
          "c": "Under",
          "v": 5.49,
          "b": false
        }
      ]
    },
    {
      "c": "AH_S1",
      "a": "-1.5",
      "b": false,
      "o": [
        {
          "c": "1",
          "v": 2.33,
          "b": false
        },
        {
          "c": "2",
          "v": 1.63,
          "b": false
        }
      ]
    },
    {
      "c": "HA_S2",
      "a": null,
      "b": false,
      "o": [
        {
          "c": "1",
          "v": 1.63,
          "b": false
        },
        {
          "c": "2",
          "v": 2.33,
          "b": false
        }
      ]
    },
    {
      "c": "OU_S2",
      "a": "6.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 1.01,
          "b": true
        },
        {
          "c": "Under",
          "v": 29,
          "b": false
        }
      ]
    },
    {
      "c": "OU_S2",
      "a": "7.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 1.03,
          "b": false
        },
        {
          "c": "Under",
          "v": 11.7,
          "b": false
        }
      ]
    },
    {
      "c": "OU_S2",
      "a": "8.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 1.17,
          "b": false
        },
        {
          "c": "Under",
          "v": 4.99,
          "b": false
        }
      ]
    },
    {
      "c": "OU_S2",
      "a": "9.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 1.63,
          "b": false
        },
        {
          "c": "Under",
          "v": 2.33,
          "b": false
        }
      ]
    },
    {
      "c": "OU_S2",
      "a": "10.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 2.8,
          "b": false
        },
        {
          "c": "Under",
          "v": 1.43,
          "b": false
        }
      ]
    },
    {
      "c": "OU_S2",
      "a": "12.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 3.78,
          "b": false
        },
        {
          "c": "Under",
          "v": 1.26,
          "b": false
        }
      ]
    },
    {
      "c": "CS_S2",
      "a": null,
      "b": false,
      "o": [
        {
          "c": "6:0",
          "v": 46,
          "b": false
        },
        {
          "c": "6:1",
          "v": 19,
          "b": false
        },
        {
          "c": "6:2",
          "v": 10,
          "b": false
        },
        {
          "c": "6:3",
          "v": 5.95,
          "b": false
        },
        {
          "c": "6:4",
          "v": 4.37,
          "b": false
        },
        {
          "c": "7:5",
          "v": 13.6,
          "b": false
        },
        {
          "c": "7:6",
          "v": 5.5,
          "b": false
        },
        {
          "c": "0:6",
          "v": 91,
          "b": false
        },
        {
          "c": "1:6",
          "v": 26,
          "b": false
        },
        {
          "c": "2:6",
          "v": 19,
          "b": false
        },
        {
          "c": "3:6",
          "v": 7.3,
          "b": false
        },
        {
          "c": "4:6",
          "v": 7.3,
          "b": false
        },
        {
          "c": "5:7",
          "v": 17.2,
          "b": false
        },
        {
          "c": "6:7",
          "v": 6.85,
          "b": false
        }
      ]
    },
    {
      "c": "IOU_T2_G",
      "a": "12.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 1.83,
          "b": false
        },
        {
          "c": "Under",
          "v": 1.94,
          "b": false
        }
      ]
    },
    {
      "c": "RTG",
      "a": "22.5",
      "b": false,
      "o": [
        {
          "c": "1/u",
          "v": 2.84,
          "b": false
        },
        {
          "c": "1/o",
          "v": 2.4,
          "b": false
        },
        {
          "c": "2/u",
          "v": 7.29,
          "b": false
        },
        {
          "c": "2/o",
          "v": 3.47,
          "b": false
        }
      ]
    },
    {
      "c": "RTG",
      "a": "23.5",
      "b": false,
      "o": [
        {
          "c": "2/u",
          "v": 6.4,
          "b": false
        },
        {
          "c": "2/o",
          "v": 3.72,
          "b": false
        },
        {
          "c": "1/u",
          "v": 2.336,
          "b": false
        },
        {
          "c": "1/o",
          "v": 2.88,
          "b": false
        }
      ]
    },
    {
      "c": "AH_S1",
      "a": "-2.5",
      "b": false,
      "o": [
        {
          "c": "1",
          "v": 5.11,
          "b": false
        },
        {
          "c": "2",
          "v": 1.16,
          "b": false
        }
      ]
    },
    {
      "c": "IOU_T1_G_S1",
      "a": "5.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 1.14,
          "b": false
        },
        {
          "c": "Under",
          "v": 5.29,
          "b": false
        }
      ]
    },
    {
      "c": "IOU_T2_G_S1",
      "a": "5.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 1.52,
          "b": false
        },
        {
          "c": "Under",
          "v": 2.48,
          "b": false
        }
      ]
    },
    {
      "c": "OU",
      "a": "23.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 1.69,
          "b": false
        },
        {
          "c": "Under",
          "v": 2.15,
          "b": false
        }
      ]
    },
    {
      "c": "AH",
      "a": "-4",
      "b": false,
      "o": [
        {
          "c": "1",
          "v": 3.09,
          "b": false
        },
        {
          "c": "2",
          "v": 1.36,
          "b": false
        }
      ]
    },
    {
      "c": "AH",
      "a": "-3.5",
      "b": false,
      "o": [
        {
          "c": "1",
          "v": 2.51,
          "b": false
        },
        {
          "c": "2",
          "v": 1.52,
          "b": false
        }
      ]
    },
    {
      "c": "AH",
      "a": "-3",
      "b": false,
      "o": [
        {
          "c": "1",
          "v": 2.14,
          "b": false
        },
        {
          "c": "2",
          "v": 1.69,
          "b": false
        }
      ]
    },
    {
      "c": "IOU_T1_G",
      "a": "13.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 2.12,
          "b": false
        },
        {
          "c": "Under",
          "v": 1.69,
          "b": false
        }
      ]
    },
    {
      "c": "IOU_T1_G",
      "a": "14.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 2.72,
          "b": false
        },
        {
          "c": "Under",
          "v": 1.44,
          "b": false
        }
      ]
    },
    {
      "c": "RTG",
      "a": "20.5",
      "b": false,
      "o": [
        {
          "c": "1/u",
          "v": 4.64,
          "b": false
        },
        {
          "c": "1/o",
          "v": 1.85,
          "b": false
        }
      ]
    },
    {
      "c": "RTG",
      "a": "21.5",
      "b": false,
      "o": [
        {
          "c": "1/u",
          "v": 3.456,
          "b": false
        },
        {
          "c": "1/o",
          "v": 2.11,
          "b": false
        }
      ]
    },
    {
      "c": "AH_S1",
      "a": "1.5",
      "b": false,
      "o": [
        {
          "c": "1",
          "v": 1.14,
          "b": false
        },
        {
          "c": "2",
          "v": 5.46,
          "b": false
        }
      ]
    },
    {
      "c": "IOU_T1_G_S1",
      "a": "6.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 2.47,
          "b": false
        },
        {
          "c": "Under",
          "v": 1.52,
          "b": false
        }
      ]
    },
    {
      "c": "IOU_T2_G_S1",
      "a": "4.5",
      "b": false,
      "o": [
        {
          "c": "Under",
          "v": 2.79,
          "b": false
        },
        {
          "c": "Over",
          "v": 1.42,
          "b": false
        }
      ]
    },
    {
      "c": "IOU_T1_G_S2",
      "a": "5.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 1.42,
          "b": false
        },
        {
          "c": "Under",
          "v": 2.79,
          "b": false
        }
      ]
    },
    {
      "c": "RTG",
      "a": "24.5",
      "b": false,
      "o": [
        {
          "c": "2/u",
          "v": 6.19,
          "b": false
        },
        {
          "c": "2/o",
          "v": 3.72,
          "b": false
        },
        {
          "c": "1/u",
          "v": 2.47,
          "b": false
        },
        {
          "c": "1/o",
          "v": 2.65,
          "b": false
        }
      ]
    },
    {
      "c": "OU",
      "a": "23",
      "b": false,
      "o": [
        {
          "c": "Under",
          "v": 2.11,
          "b": false
        },
        {
          "c": "Over",
          "v": 1.7,
          "b": false
        }
      ]
    },
    {
      "c": "OU",
      "a": "24.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 1.84,
          "b": false
        },
        {
          "c": "Under",
          "v": 1.95,
          "b": false
        }
      ]
    },
    {
      "c": "OU",
      "a": "25",
      "b": false,
      "o": [
        {
          "c": "Under",
          "v": 1.78,
          "b": false
        },
        {
          "c": "Over",
          "v": 2,
          "b": false
        }
      ]
    },
    {
      "c": "OU",
      "a": "28.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 2.32,
          "b": false
        },
        {
          "c": "Under",
          "v": 1.6,
          "b": false
        }
      ]
    },
    {
      "c": "OU",
      "a": "22",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 1.4,
          "b": false
        },
        {
          "c": "Under",
          "v": 2.93,
          "b": false
        }
      ]
    },
    {
      "c": "IOU_T1_G",
      "a": "15.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 3.15,
          "b": false
        },
        {
          "c": "Under",
          "v": 1.34,
          "b": false
        }
      ]
    },
    {
      "c": "RTG",
      "a": "25.5",
      "b": false,
      "o": [
        {
          "c": "2/u",
          "v": 5.51,
          "b": false
        },
        {
          "c": "2/o",
          "v": 4.02,
          "b": false
        },
        {
          "c": "1/u",
          "v": 2.1,
          "b": false
        },
        {
          "c": "1/o",
          "v": 3.35,
          "b": false
        }
      ]
    },
    {
      "c": "RTG",
      "a": "26.5",
      "b": false,
      "o": [
        {
          "c": "2/u",
          "v": 4,
          "b": false
        },
        {
          "c": "2/o",
          "v": 4.36,
          "b": false
        }
      ]
    },
    {
      "c": "OU",
      "a": "25.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 2.1,
          "b": false
        },
        {
          "c": "Under",
          "v": 1.7,
          "b": false
        }
      ]
    },
    {
      "c": "OU",
      "a": "26",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 2.24,
          "b": false
        },
        {
          "c": "Under",
          "v": 1.62,
          "b": false
        }
      ]
    },
    {
      "c": "IOU_T2_G_S2",
      "a": "5.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 1.76,
          "b": false
        },
        {
          "c": "Under",
          "v": 2.02,
          "b": false
        }
      ]
    },
    {
      "c": "AH",
      "a": "-0.5",
      "b": false,
      "o": [
        {
          "c": "1",
          "v": 1.5,
          "b": false
        },
        {
          "c": "2",
          "v": 2.55,
          "b": false
        }
      ]
    },
    {
      "c": "AH",
      "a": "0.5",
      "b": false,
      "o": [
        {
          "c": "1",
          "v": 1.43,
          "b": false
        },
        {
          "c": "2",
          "v": 2.79,
          "b": false
        }
      ]
    },
    {
      "c": "IOU_T2_G",
      "a": "13.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 2.35,
          "b": false
        },
        {
          "c": "Under",
          "v": 1.57,
          "b": false
        }
      ]
    },
    {
      "c": "RTG_S1",
      "a": "10.5",
      "b": false,
      "o": [
        {
          "c": "1/u",
          "v": 2.864,
          "b": false
        },
        {
          "c": "1/o",
          "v": 2.55,
          "b": false
        }
      ]
    },
    {
      "c": "RTG_S1",
      "a": "12.5",
      "b": false,
      "o": [
        {
          "c": "2/u",
          "v": 4.54,
          "b": false
        },
        {
          "c": "2/o",
          "v": 3.85,
          "b": false
        }
      ]
    },
    {
      "c": "IOU_T2_G_S1",
      "a": "6.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 4,
          "b": false
        },
        {
          "c": "Under",
          "v": 1.23,
          "b": false
        }
      ]
    },
    {
      "c": "OU",
      "a": "24",
      "b": false,
      "o": [
        {
          "c": "Under",
          "v": 1.93,
          "b": false
        },
        {
          "c": "Over",
          "v": 1.91,
          "b": false
        }
      ]
    },
    {
      "c": "AH",
      "a": "-2",
      "b": false,
      "o": [
        {
          "c": "1",
          "v": 1.69,
          "b": false
        },
        {
          "c": "2",
          "v": 2.14,
          "b": false
        }
      ]
    },
    {
      "c": "OU",
      "a": "27",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 2.42,
          "b": false
        },
        {
          "c": "Under",
          "v": 1.54,
          "b": false
        }
      ]
    },
    {
      "c": "AH",
      "a": "-1.5",
      "b": false,
      "o": [
        {
          "c": "1",
          "v": 1.61,
          "b": false
        },
        {
          "c": "2",
          "v": 2.29,
          "b": false
        }
      ]
    },
    {
      "c": "AH",
      "a": "-1",
      "b": false,
      "o": [
        {
          "c": "1",
          "v": 1.53,
          "b": false
        },
        {
          "c": "2",
          "v": 2.46,
          "b": false
        }
      ]
    },
    {
      "c": "AH",
      "a": "-5",
      "b": false,
      "o": [
        {
          "c": "1",
          "v": 7.55,
          "b": false
        },
        {
          "c": "2",
          "v": 1.08,
          "b": false
        }
      ]
    },
    {
      "c": "AH",
      "a": "-4.5",
      "b": false,
      "o": [
        {
          "c": "1",
          "v": 3.37,
          "b": false
        },
        {
          "c": "2",
          "v": 1.31,
          "b": false
        }
      ]
    },
    {
      "c": "IOU_T2_G",
      "a": "10.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 1.52,
          "b": false
        },
        {
          "c": "Under",
          "v": 2.45,
          "b": false
        }
      ]
    },
    {
      "c": "IOU_T1_G_S1",
      "a": "4.5",
      "b": false,
      "o": [
        {
          "c": "Over",
          "v": 1.05,
          "b": false
        },
        {
          "c": "Under",
          "v": 9.09,
          "b": false
        }
      ]
    },
    {
      "c": "RTG",
      "a": "27.5",
      "b": false,
      "o": [
        {
          "c": "2/u",
          "v": 4.73,
          "b": false
        },
        {
          "c": "2/o",
          "v": 4.6,
          "b": false
        }
      ]
    }
  ],
  "ss": {
    "h": "0",
    "a": "0"
  },
  "turn": "h",
  "wh": {
    "i": null,
    "d": "",
    "tp": "",
    "wn": {
      "i": null,
      "s": "",
      "dir": ""
    },
    "ps": {
      "v": "",
      "d": ""
    },
    "hm": {
      "v": "",
      "d": ""
    }
  }
}
export default class TennisBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      gameCode: "2",
      scoreData: data,
      tvShow: true,
      tvUrl: ""
    };
  }
  componentDidMount() {
    setInterval(() => { this.setState({}) }, 1000)
  }
  formatDate(date) {
    if (!date) {
      return ""
    }
    date = new Date(date)
    let month = [];
    month[0] = "Jan";
    month[1] = "Feb";
    month[2] = "Mar";
    month[3] = "Apr";
    month[4] = "May";
    month[5] = "Jun";
    month[6] = "Jul";
    month[7] = "Aug";
    month[8] = "Sept";
    month[9] = "Oct";
    month[10] = "Nov";
    month[11] = "Dec";
    let mn = date.getMonth() + 1;
    mn = mn > 9 ? mn : "0" + mn
    let dt = date.getDate();
    dt = dt > 9 ? dt : "0" + dt
    let hr = date.getHours();
    hr = hr > 9 ? hr : "0" + hr
    let min = date.getMinutes();
    min = min > 9 ? min : "0" + min
    let year = date.getFullYear()
    let formatedDate = dt + "/" + mn + "/" + year + " " + hr + ":" + min
    return formatedDate
  }
  render() {
    let now = new Date().getTime()
    let eventTime = !!this.props.game && !!this.props.game.event && !!this.props.game.event["openDate"] ? new Date(this.props.game.event["openDate"]).getTime() : now
    let isOpen = !!this.props.game && !!this.props.game.event && !!this.props.game.event["openDate"] ? new Date(this.props.game.event["openDate"]).getTime() < now : false
    let score = this.props.frontData
    return (
      <div className=" live-match">
        <div className={score !== null && !!score.i ? "sub_path center-box crname" : "sub_path center-box crname mb-2"}>
          <p>
            {!!this.props.game && !!this.props.game.event && !!this.props.game.competition && <><span>{!!this.props.game && !!this.props.game.event["name"] ? this.props.game.event["name"] : null} - {!!this.props.game && !!this.props.game.competition["name"] ? this.props.game.competition["name"] : null}</span> <span className="f-right">{this.formatDate(this.props.game.event["openDate"])}</span></>}
          </p>
        </div>
        <div className="livetv mt-1">
          {!!this.props.tvUrl && this.props.tvUrl !== "" && <>
            <div className="sub_path center-box crname">
              <p>
                <span>Live TV</span>
                <div className="custom-control custom-switch float-right" style={{ display: "inline" }} onClick={() => { this.props.onOffTv() }}>
                  <input type="checkbox" className="custom-control-input" checked={this.props.tvShow} />
                  <label className="custom-control-label" for="customSwitches"></label>
                </div>
              </p>
            </div>
            <div className="game-wrap col3 mb-0 pb-0">
              {this.props.tvShow && <div className="mobiletviframe">
                {!this.props.isNoBalence ? <iframe title={"iframe"} key={"iframe"} id='fp_embed_player' src={this.props.tvUrl} marginWidth='0' marginHeight='0' frameBorder='0' width='100%' height='100%' scrolling='no' allowFullScreen='allowfullscreen'></iframe> :
                  <div className='no-balence'>You Don't have enough balance to watch Live TV.</div>
                }
              </div>}</div>
          </>
          }
        </div>
        {score !== null && !!score.i && <div className="game-wrap col3 mb-0">
          <div className="middle-in-play">
            {!isOpen ? <EventTimer duration={(eventTime - now) / 1000} /> :
              <div className="event-main-box team-score-details tennisbgbox ">
                <div className="row">
                  <div className="col-12">
                    <div className="table-responsive">
                      <table className="table table-sm tennisscore">
                        <tbody>
                          <tr className="text-center">
                            <td className="width-10tennis"></td>
                            <td className="text-left">Player</td>
                            <td>1</td>
                            <td>2</td>
                            <td>3</td>
                            <td>4</td>
                            <td>5</td>
                            <td>Points</td>
                            <td>Sets</td>
                          </tr>
                          <tr className="text-center tennisbgblack">
                            <td className="width-10tennis">{!!score && !!score.turn && score.turn === "h" && <span className="soccer-lvnow"></span>}</td>
                            <td className="text-left">{!!score && !!score.c1 ? this.props.runners[0].name : this.props.runners[0].name} <span></span> </td>
                            <td className={!!score && !!score.ps && !!score.ps.S1 && score.ps.S1.status === 1 ? "text-success bg-black top-radius" : ""}>{!!score && !!score.ps && !!score.ps.S1 ? score.ps.S1.games.h : "0"}</td>
                            <td className={!!score && !!score.ps && !!score.ps.S2 && score.ps.S2.status === 1 ? "text-success bg-black" : ""}>{!!score && !!score.ps && !!score.ps.S2 ? score.ps.S2.games.h : "0"}</td>
                            <td className={!!score && !!score.ps && !!score.ps.S3 && score.ps.S3.status === 1 ? "text-success bg-black" : ""}>{!!score && !!score.ps && !!score.ps.S3 ? score.ps.S3.games.h : "0"}</td>
                            <td className={!!score && !!score.ps && !!score.ps.S4 && score.ps.S4.status === 1 ? "text-success bg-black" : ""}>{!!score && !!score.ps && !!score.ps.S4 ? score.ps.S4.games.h : "0"}</td>
                            <td className={!!score && !!score.ps && !!score.ps.S5 && score.ps.S5.status === 1 ? "text-success bg-black" : ""}>{!!score && !!score.ps && !!score.ps.S5 ? score.ps.S5.games.h : "0"}</td>
                            <td className="points top-radius">{!!score && !!score.ss ? score.ss.h : "0"}</td>
                            <td>{!!score && !!score.ps && !!score.ps.TN ? score.ps.TN.sets.h : "0"}</td>
                          </tr>
                          <tr className="text-center tennisbgblack">
                            <td className="width-10tennis">{!!score && !!score.turn && score.turn === "a" && <span className="soccer-lvnow"></span>}</td>
                            <td className="text-left">{!!score && !!score.c2 ? this.props.runners[1].name : this.props.runners[1].name} <span></span></td>
                            <td className={!!score && !!score.ps && !!score.ps.S1 && score.ps.S1.status === 1 ? "text-success bg-black bottom-radius" : ""}>{!!score && !!score.ps && !!score.ps.S1 ? score.ps.S1.games.a : "0"}</td>
                            <td className={!!score && !!score.ps && !!score.ps.S2 && score.ps.S2.status === 1 ? "text-success bg-black" : ""}>{!!score && !!score.ps && !!score.ps.S2 ? score.ps.S2.games.a : "0"}</td>
                            <td className={!!score && !!score.ps && !!score.ps.S3 && score.ps.S3.status === 1 ? "text-success bg-black" : ""}>{!!score && !!score.ps && !!score.ps.S3 ? score.ps.S3.games.a : "0"}</td>
                            <td className={!!score && !!score.ps && !!score.ps.S4 && score.ps.S4.status === 1 ? "text-success bg-black" : ""}>{!!score && !!score.ps && !!score.ps.S4 ? score.ps.S4.games.a : "0"}</td>
                            <td className={!!score && !!score.ps && !!score.ps.S5 && score.ps.S5.status === 1 ? "text-success bg-black" : ""}>{!!score && !!score.ps && !!score.ps.S5 ? score.ps.S5.games.a : "0"}</td>
                            <td className="points bottom-radius">{!!score && !!score.ss ? score.ss.a : "0"}</td>
                            <td>{!!score && !!score.ps && !!score.ps.TN ? score.ps.TN.sets.a : "0"}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
        }
      </div>
    )
  }
}
